/**
 * Full-screen labs a Study tool opens that need no sign-in. They are part of the Study experience, so the
 * fictional student can open them from the Chemistry tools (the Physics Lab requires sign-in and stays out).
 */
export const STUDY_EXPERIENCE_LAB_PATHS: readonly string[] = ['/labs/chemistry'];
